// class components have constructors that run only once, so class components are required
class LocalStoragePersistenceService {
  _appId;

  constructor(appId) {
    this._appId = appId;
  }

  setUpdateIsNeeded() {
    window.localStorage.setItem(this._key(), JSON.stringify(true));
  }

  clear() {
    window.localStorage.setItem(this._key(), JSON.stringify(false));
  }

  isUpdateNeeded() {
    return JSON.parse(window.localStorage.getItem(this._key()) ?? 'false');
  }

  _key() {
    return `LocalStoragePersistenceService-${this._appId}`;
  }
}

export default LocalStoragePersistenceService;
